<template>
  <div class="station-list">
    <div
      v-if="loading"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <dl
      v-for="(item, index) in list"
      v-else
      :key="index"
      :ref="`item${index}`"
    >
      <dt
        class="clearfix"
      >
        <div
          class="left fl"
          @click="toggleDetail(item, index)"
        >
          <span
            class="time"
            :class="{'fs-bold': !item.isread}"
          >{{ $moment(item.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</span>
          <span
            class="title"
            :class="{'fs-bold': !item.isread}"
          >{{ item.title }}</span>
        </div>
        <a
          class="detail-btn fr"
          @click="toggleDetail(item, index)"
        >
          <span class="fs-blue">{{ $t('message["1316"]') }}</span>
          <i
            class="iconfont"
            :class="{'iconicon-test18': item.open, 'iconicon-test19': !item.open}"
          />
        </a>
      </dt>
      <dd
        v-show="item.open"
        class="chrome_scrollbar"
      >
        <div
          class="detail"
          v-html="item.content"
        />
      </dd>
    </dl>
    <div
      v-if="loading === false && !list.length"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p class="placeholder">
        {{ $t('message["1553"]') }}
      </p>
    </div>
    <a-button
      v-if="list.length >= 10"
      :loading="loading"
      :disabled="loading"
      class="load-more-btn"
      @click="fetchData"
    >
      {{ $t('message["472"]') }}
    </a-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'StationList',
  data () {
    return {
      list: [],
      page: 1,
      loading: null
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapActions('newFeature', ['getStationMessage', 'readStationMessage']),

    async fetchData () {
      this.loading = true

      let chain = await this.getStationMessage({
        page: this.page
      })
      chain.onSuccess(res => {
        this.loading = false
        let { list } = res || {}

        if (list.length) {
          this.page++
          this.list.push(...list)
        } else if (this.page > 1) {
          this.$message.destroy()
          this.$message.warning(this.$t('message["1463"]') + '！')
        }
      })
    },
    async toggleDetail (item, index) {
      let chain = await this.readStationMessage({
        id: item.id
      })
      chain.onSuccess(res => {
        item.isread = true
      })

      this.list.forEach((one, i) => {
        if (index === i) {
          this.$set(item, 'open', !item.open)
        } else {
          this.$set(one, 'open', false)
        }
      })

      if (this.$refs['item' + index] && this.$refs['item' + index][0]) {
        this.$refs['item' + index][0].scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.station-list {
  dt {
    padding: 12px 0;
    line-height: 24px;
    color: #666;
    &.bold {
      font-weight: bold;
    }
  }
  .time {
    margin-right: 16px;
  }
  .left {
    cursor: pointer;
  }
  .detail-btn {
    .iconfont {
      margin-left: 6px;
    }
  }
  dd {
    overflow: auto;
    background: #F5F6F7;
    border-top: solid 1px #ebebeb;
    .detail ::v-deep {
      max-height: 320px;
      padding: 16px;

      img {
        max-width: 100%;
      }
      strong {
        font-weight: bold;
      }
      pre {
        margin: .5em 0;
        padding: .4em .6em;
        border-radius: 8px;
        background: #f8f8f8;
      }
    }
  }
}
.empty-box {
  .logo {
    margin-top: 120px;
  }
}
</style>
